import { CSSObject } from '@chakra-ui/react';

export const FooterMoreOpenText: CSSObject = {
  color: 'blue.400',
};

export const toteMultiGrid: CSSObject = {
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '6',
  display: 'grid',
};

export const toteMultiGridText: CSSObject = {
  fontSize: 'xs',
  w: 'full',
  color: 'alpha.700',
  mb: '2',
  '&.raceNumber': {
    fontWeight: 'bold',
    borderBottom: '1px dashed',
    borderColor: 'rgba(0, 0, 0, 0.16)',
    boxShadow: '0px 1px 0px 0px #FFFFFF1A',
  },
};
